export default "__VITE_ASSET__b25aa0ae__"